import { PROJECTS } from "../../../utils/project"
import { ApiSupportSelector } from "../../helpers/apiSupport"
import { InitialState } from "../reducers"

export const Selector = {
    get: (state): InitialState => {
        return state.project
    },

    getStructured: (state) => {
        return {
            id: Selector.get(state).id,
            type: PROJECTS,
            attributes: Selector.get(state),
        }
    },

    getApiStatus: (state) => {
        return ApiSupportSelector(Selector.get(state))
    },

    getToEmail: (state) => {
        return Selector.get(state).contact?.attributes?.email ?? ""
    },
}


// WEBPACK FOOTER //
// ./src/state/project/selectors/selectors.ts